import { appId } from '@customer-apps/app-context/app-context.service';

export const baseEnvironment = {
  production: true,
  appId: 'club_member_app' as appId,
  appType: 'end_user',
  institutionType: 'club',
  assetVersion: '3',
  appVersion: '15.0.0',
  appUrlRegex: /^https?:\/\/(?:localhost:9400|www\.clubity\.com|stage\d+\.clubity\.com)\/app(.*)/,
  apiHost: null, // can be used if the api is hosted on another domain then the webapp or if the webapp gets compiled as a native cordova wrapapp
  apiPath: '/apis/club-member-app',
  htmlTitle: 'Clubity – Your club. Your community. You.',
  titleSuffix: 'Clubity',
  privacyUrl: null,
  imprintUrl: null, // custom apps might want to provide their own external imprint
  staleTokenAgeInSeconds: 1296000, // refresh if token expires in less than 15 days (token ttl is 30 days),
  pushChannelName: 'Clubity – Your club. Your community. You.',
  clientLogoFileName: 'logo.svg',
  clientInvertedLogoFileName: 'logo-inverted.svg',
  platformOrganization: {
    name: 'Speicherhafen GmbH & CO. KG',
    street: 'Am Sandtorkai 1',
    zip: '20457',
    city: 'Hamburg',
    email: 'contact@clubity.com',
    phone: '+49 (0)40 30 30 66 993',
    fax: '+49 (0)40 30 30 66 996',
    homepage: 'https://www.clubity.com',
    chiefExecutiveOfficer: 'Dipl. iur. Moritz von Bismarck, MBA',
    taxNumber: 'DE 280336234',
    registrationCourt: 'Amtsgericht Hamburg',
    companyRegistrationNumber: 'HRA 114 128',
  },
  organization: null, // allow login to this organization only
  federationIds: null, // allow login to organizations belonging to these federations only (or to white-listed organizations)
  organizationIds: null, // allow login to these organizations only (or to white-listed federations)
  firebase: {
    apiKey: 'AIzaSyAssTES9uL0Fl4F26IuwQ1uyhxlgnjSfjA',
    projectId: 'speicherhafen',
    messagingSenderId: '1087915507372',
    appId: '1:1087915507372:web:9690f5999cf15acae72909',
  },
  sentryEnvironment: 'club-member-app',
};
